export default __webpack_public_path__ + "static/media/playGame.2b03566a.svg";